import { render, staticRenderFns } from "./DeviceFilterReviews.vue?vue&type=template&id=e5acbb42"
import script from "./DeviceFilterReviews.vue?vue&type=script&lang=js"
export * from "./DeviceFilterReviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports